import { useTranslation } from 'react-i18next'

import { CheckIcon, XIcon } from '@phosphor-icons/react'

import { counterTypes } from '../constants'
import ImportCounterCard from './ImportCounterCard/ImportCounterCard'
import * as Styles from './styles'

const ImportCounters = ({ processedRows, errorRows }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <ImportCounterCard
        label={t('Filas importadas')}
        value={processedRows}
        Icon={CheckIcon}
        type={counterTypes.success}
      />
      <ImportCounterCard label={t('Filas con errores')} value={errorRows} Icon={XIcon} type={counterTypes.warning} />
    </Styles.Container>
  )
}

export default ImportCounters
